:host {
  --indent-size: 1rem;
  --indent-guide-width: 1px;
  --indent-guide-style: solid;
  --indent-guide-color: var(--l-color-border-interactive);
  --row-height: 1.75rem;
  --row-padding-inline: 0.25rem;
  --chevron-size: 1.125rem;
  --item-gap: 0.375rem;

  display: block;
  color: var(--l-color-text-primary);
  font-family: inherit;
  line-height: 1.5;
}

.tree {
  display: block;
  outline: none;
}

.tree:focus-visible {
  outline: 2px solid var(--l-focus-ring);
  outline-offset: 2px;
  border-radius: 0.375rem;
}
